import type { BillingTier, UsageReport } from "@/lib/api/billing";
import { formatTailors, tailorsLeft } from "@/lib/overview";

export const TIER_LABEL: Record<BillingTier, string> = { free: "Free", pro: "Pro", max: "Max" };

/** "Pro · 7.5 of 25 left", under the person's name. Empty while either is unknown. */
export function planLine(tier: BillingTier | undefined, usage: UsageReport | undefined): string {
    if (!tier) return "";
    const tailors = usage ? tailorsLeft(usage) : null;
    if (!tailors) return TIER_LABEL[tier];
    // The period's own: "of 25" is the plan's cap, so packs are not in it.
    return `${TIER_LABEL[tier]} · ${formatTailors(tailors.left - tailors.packs)} of ${formatTailors(tailors.limit)} left`;
}
